export default __webpack_public_path__ + "static/media/025-bottle.a0492d86.png";